var map = {
	"./BestExpress.png": "dd5a",
	"./Deppon.png": "158b",
	"./EMS.png": "76a1",
	"./SF.png": "9935",
	"./YTO.png": "9ed4",
	"./Yunda.png": "9a51",
	"./ZTO.png": "315a",
	"./otherExpress.png": "8c1a",
	"./shentong.png": "4fe5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "53bc";